import React from 'react'
import Menu from '../components/Navbar'
import { Container } from 'react-bootstrap'
import MortaraWhiteLogo from '../img/Mortara-White.png'
import contentAbout1 from '../img/contentAbout1.png'
import contentAbout2 from '../img/contentAbout2.png'
import VisionMission from '../img/vision-mission.png'
import Footer from '../components/Footer'
import MortaraBlack from '../img/Mortara-Black.png'

// Import Image
import Artikel1 from '../img/aboutus1.png'
import Artikel2 from '../img/aboutus2.png'
import Artikel3 from '../img/aboutus3.png'

const AboutUs = () => {

  // const Image = () => {
  //   return <img src={Artikel1} alt="" />
  // }
  // const Image2 = () => {
  //   return <img src={Artikel2} alt="" />
  // }
  // const Image3 = () => {
  //   return <img src={Artikel3} alt="" />
  // }

  return (
    <>
      <Menu />
      <Container fluid className="content-aboutus">
        <div className="Image-aboutus">
            <div className="container-image1">
                <div className="paragraf">
                    <h1>Tentang Kami</h1>
                </div>
            </div>
        </div>
      </Container>

      <Container fluid className="containerContentAbout">
          <div className="contentAbout">
            <h1>Tentang Kami</h1>
            <p>Mortara adalah perusahaan konstruksi yang menggabungkan perencanaan teknis,
desain yang realistis untuk diwujudkan, dan eksekusi lapangan yang presisi. Kami
menangani berbagai jenis proyek, mulai dari hunian, kantor, hingga fasilitas olahraga,
dengan proses yang terukur dan disiplin.</p>
            <img src={ contentAbout1 } alt="" />
          </div>
          <div className="contentAbout">
            {/* <h1>About Us</h1> */}
            <p className="contentAbout2">Setiap pekerjaan dijalankan melalui tahapan yang jelas, mulai dari perencanaan
anggaran, pengembangan desain, hingga pembangunan. Fokus kami adalah
memastikan setiap hasil pekerjaan rapi dan presisi, sesuai standar teknis yang berlaku.</p>
            <img src={ contentAbout2 } alt="" />
          </div>
      </Container>

      <Container fluid className="containerVisiMission">
        <div className="textVisiMission">
          <h1>Visi & Misi</h1>
          <p>Mortara mengutamakan presisi dan kejelasan proses dalam setiap proyek. Dengan
perencanaan teknis yang terukur, desain yang realistis, dan eksekusi lapangan yang
disiplin, kami memastikan hasil akhir yang rapi, aman, dan konsisten pada standar teknis.</p>
        </div>
        <div className="imgVisiMission">
          <img src={ VisionMission } alt="" />
        </div>
      </Container>

      <Container fluid className="contArtikel">
          <div className="containerArtikel">
            <div className="mortaraArtikel">
              <img src={MortaraBlack} alt="" />
            </div>
            <div className="textArtikel">
              <p>Mortara mendampingi seluruh proses pembangunan Anda, mulai dari perencanaan
teknis, penyusunan anggaran, hingga konstruksi. Kami memastikan setiap tahap berjalan
jelas dan memenuhi standar kualitas yang kami tetapkan.</p>
            </div>
            <div className="embedInstagram mb-5">
              <div className="elfsight-app-b507292a-74b4-4f15-b347-5adc8613d534"></div>
            </div>
          </div>
      </Container>
      <Footer />
    </>
  )
}

export default AboutUs